import clsx from 'clsx';
import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

export default function ContactForm({ blok }) {
  const styles = clsx('blok-contact-form text-center m-auto max-w-5xl px-4 lg:px-16');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {blok?.blocks.map((block) => (
        <StoryblokComponent blok={block} key={block._uid} />
      ))}
    </div>
  );
}
